import React from 'react';

const KeteranganTidakAbsen = () => {
  return (
    <h1>Keterangan Tidak Absen</h1>
  );
};

export default KeteranganTidakAbsen;





